import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import stateSelector from 'reduxModules/cart/selectors'
import { cartMergeProps as mergeProps } from 'reduxModules/cart/dispatchers'
import _ from 'lodash'
import classnames from 'classnames'
import Helmet from 'react-helmet'
import CartItemList from './CartItemList'
import DiscountCode from '../DiscountCode'
import Tutorial from '../generic/CourseSummary'
import math from '../../redux/modules/utils/math'
import withRouterV6 from '../../utils/withRouterV6'
import './styles.css'

export class Cart extends Component {
  componentDidMount() {
    const { location, loginFromEmail, isLoggedIn } = this.props

    if (_.has(location, 'query.token'))
      loginFromEmail(location.query, isLoggedIn)

    this.props.loadSubscriptionPlans()
    this.props.loadRelatedItems()
  }

  render() {
    const { isMobile } = this.props
    const validatedCode = this.props.validatedDiscountCode
    return (
      <div id="Cart">
        <Helmet>
          <title>Your Cart | Stan Winston School of Character Arts</title>
        </Helmet>
        <div className="wrapper">
          <section className="heading"><h1>Your cart</h1></section>
        </div>
        {!isMobile && (
          <section className="hero">
            <div className="headline">
              <p>You have <span className="accent">{this.props.count}</span> {this.props.count === 1 ? 'item' : 'items'} in your cart</p>
            </div>
            <div className="checkout-button">
              {this.props.count > 0 && (
                <button onClick={() => this.props.checkoutCart()}>
                  checkout
                </button>
              )}
            </div>
          </section>
        )}
        {!this.props.isMobile && (
          <section className="items wrapper">
            {this.props.count > 0 && (
              <CartItemList
                items={this.props.cartItems}
                loading={this.props.loading}
                isMobile={false}
                subscription={this.props.subscription}
                plans={this.props.plans}
                subscriptionDiscount={this.props.subscriptionDiscount}
              />
            )}
          </section>
        )}
        <section className={classnames('mid-section wrapper', { 'with-related-items': Array.isArray(this.props.related) && this.props.related.length > 0 })}>
          {!isMobile && (
            <div className="terms-and-conditions">
              <h3>Terms and Conditions</h3>
              <p>
                Your Order Confirmation will include shipment details (if applicable) and estimated tax.
              </p>
              <p>
                We are not responsible for customer typographical errors. Not all items may be available. We reserve the right to limit quantities, including the right to prohibit sales to resellers.
              </p>
            </div>
          )}
          <div className="order-summary-box">
            <div className="order-summary">
              <div className="title">
                <span>order summary</span>
              </div>
              <div className="body">
                <div className="subtitles">
                  <span className="property">{this.props.count > 1 ? 'items' : 'item'} ({this.props.count}):</span>
                  {!validatedCode.codename && (
                    <label
                      className="property redeem-cta"
                      htmlFor="discount-code-input"
                      onClick={() => { this.props.toggleDiscountCode() }}
                    >
                      Redeem a discount code
                    </label>
                  )}
                  {!validatedCode.codename && <DiscountCode />}
                  {validatedCode.codename && (
                    <span className="property redeemed">Redeemed Code:</span>
                  )}
                </div>
                <div className="values">
                  <span className="property">${this.props.subtotal}</span>
                  <span className="property">
                    {!validatedCode.codename && <span>---</span>}
                    {validatedCode.codename && (
                      <span>
                        <span className="minus">- </span>
                        ${math.toFixed(validatedCode.discount)}<br />
                        &quot;{validatedCode.codename}&quot;
                      </span>
                    )}
                  </span>
                </div>
              </div>
              <div className="total">
                <span>order total:</span>
                <span>${this.props.total}</span>
              </div>
              <div className={classnames('checkout-button', { 'justify-end': !isMobile })}>
                {this.props.count > 0 && (
                  <button onClick={() => this.props.checkoutCart()}>
                    checkout
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
        {this.props.isMobile && (
          <section className="items wrapper">
            {this.props.count > 0 && (
              <CartItemList
                items={this.props.cartItems}
                loading={this.props.loading}
                isMobile
                subscription={this.props.subscription}
                plans={this.props.plans}
                subscriptionDiscount={this.props.subscriptionDiscount}
              />
            )}
          </section>
        )}
        {Array.isArray(this.props.related) && this.props.related.length > 0 && (
          <section className="related-items wrapper">
            <h3 className="related-items__title">You may also be interested in</h3>
            <div className="course-list">
              {this.props.related.map(tutorial => (
                <Tutorial
                  className="tutorial"
                  key={`tutorial-${tutorial.id}`}
                  slug={tutorial.slug}
                  summary={tutorial.description}
                  teacher={tutorial.artist.title}
                  teacherSlug={tutorial.artist.slug}
                  thumb={tutorial.photo.boxThumb}
                  title={tutorial.title}
                  new={tutorial.new}
                />
              ))}
            </div>
          </section>
        )}
      </div>
    )
  }
}

export const cartPropTypes = {
  cartItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  subtotal: PropTypes.string.isRequired
}

Cart.propTypes = {
  ...cartPropTypes,
  loadCartItems: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
}

Cart.defaultProps = {
  isMobile: false,
  related: []
}

export default withRouterV6(connect(
  stateSelector,
  null,
  mergeProps
)(Cart))
